/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deploymentSync} from '../api'

export const useMutationDeploymentSync = createReactQueryMutationHook('deploymentSync', deploymentSync)
